import { attendanceConstants } from '../actions/constants/attendanceConstants';

const initialState = {
  attendanceData: null as any,
  loading: false,
  error: null as any,
  lastMarked: null as any,
};

const attendanceReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case attendanceConstants.markAttendanceRequest:
      return { 
        ...state, 
        loading: true, 
        error: null 
    };
    case attendanceConstants.markAttendanceSuccess:
      return { 
        ...state, 
        loading: false, 
        lastMarked: action.payload, 
        error: null 
    };
    case attendanceConstants.markAttendanceFailure:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
    };

    case attendanceConstants.getEventAttendanceRequest:
      return { 
        ...state, 
        loading: true, 
        error: null
     };
    case attendanceConstants.getEventAttendanceSuccess:
      return { 
        ...state, 
        loading: false, 
        attendanceData: action.payload, 
        error: null 
    };
    case attendanceConstants.getEventAttendanceFailure:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
    };

    default:
      return state;
  }
};

export const markAttendanceReducer = (state = { loading: false, error: null, lastMarked: null }, action: any) => {
  switch (action.type) {
    case attendanceConstants.markAttendanceRequest:
      return { 
        ...state, 
        loading: true, 
        error: null 
    };
    case attendanceConstants.markAttendanceSuccess:
      return { 
        ...state, 
        loading: false,
        lastMarked: action.payload,
        error: null
      };
    case attendanceConstants.markAttendanceFailure:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
    };
    default:
      return state;
  }
};

export const eventAttendanceReducer = (state = { attendanceData: null, loading: false, error: null }, action: any) => {
  switch (action.type) {
    case attendanceConstants.getEventAttendanceRequest:
      return { 
        ...state, 
        loading: true, 
        error: null 
    };
    case attendanceConstants.getEventAttendanceSuccess:
      return { 
        ...state, 
        loading: false, 
        attendanceData: action.payload, 
        error: null 
    };
    case attendanceConstants.getEventAttendanceFailure:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
    };
    default:
      return state;
  }
};

export default attendanceReducer;
